import React, { useCallback, useRef } from 'react';
import { GoogleMap, Marker, StandaloneSearchBox, LoadScriptNext } from '@react-google-maps/api';
import './MarkerMap.scss';
import ErrorBoundary from './ErrorBoundary';
import { Libraries } from '@react-google-maps/api/dist/utils/make-load-script-url';

interface Props {
  readOnly?: boolean;
  lat?: number;
  lng?: number;
  width: string;
  height: string;
  onChange: (lat: number, lng: number) => void;
}

const libs: Libraries = ['places'];
const options = {
  // zoomControlOptions: {
  //   position: google.maps.ControlPosition.RIGHT_CENTER,
  // },
};

const MarkerMap: React.FunctionComponent<Props> = (props) => {
  let searchBox = useRef<google.maps.places.SearchBox>();

  const onLoad = useCallback((mapInstance: any) => {}, []);

  const onDragEnd = (event: google.maps.MouseEvent) => {
    props.onChange(event.latLng.lat(), event.latLng.lng());
  };

  const onClick = (event: google.maps.MouseEvent) => {
    props.onChange(event.latLng.lat(), event.latLng.lng());
  };

  const onPlacesChanged = () => {
    if (searchBox && searchBox.current) {
      const places = searchBox.current.getPlaces();
      if (places && places.length > 0) {
        const place = places[0];
        if (place.geometry) {
          props.onChange(place.geometry.location.lat(), place.geometry.location.lng());
        }
      }
    }
  };

  return (
    <div>
      <ErrorBoundary text="Failed to load Google Maps">
        <LoadScriptNext id="loader" googleMapsApiKey="AIzaSyA8aRaE9A2r1KIQBT93TGkVgCDt1gxfRLM" libraries={libs}>
          <GoogleMap
            options={options}
            mapContainerStyle={{
              height: props.height,
              width: props.width,
            }}
            onClick={onClick}
            zoom={15}
            center={{
              lat: props.lat || 52.22057,
              lng: props.lng || 6.88992,
            }}
            onLoad={onLoad}>
            {props.lat && props.lng && (
              <Marker
                draggable={!props.readOnly}
                onDragEnd={onDragEnd}
                position={{
                  lat: props.lat,
                  lng: props.lng,
                }}
              />
            )}
            {!props.readOnly && (
              <StandaloneSearchBox
                onLoad={(ref) => {
                  searchBox.current = ref;
                }}
                onPlacesChanged={onPlacesChanged}>
                <input
                  type="text"
                  placeholder="Search..."
                  style={{
                    boxSizing: `border-box`,
                    border: `1px solid transparent`,
                    width: `240px`,
                    height: `32px`,
                    padding: `0 12px`,
                    borderRadius: `3px`,
                    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                    fontSize: `14px`,
                    outline: `none`,
                    textOverflow: `ellipses`,
                    position: 'absolute',
                    left: '50%',
                    marginLeft: '-120px',
                  }}
                />
              </StandaloneSearchBox>
            )}
          </GoogleMap>
        </LoadScriptNext>
      </ErrorBoundary>
    </div>
  );
};

export default MarkerMap;
